import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from "@material-ui/core";
import { FieldType, useMediaQuery } from "@shoothill/core";
import { theme } from "Globals/Styles/AppTheme";
import { RadioCheckedSVG } from "Globals/Views/IconSVGs/RadioCheckedSVG";
import { RadioSVG } from "Globals/Views/IconSVGs/RadioSVG";
import React from "react";

interface IProps<T> {
    label?: string | JSX.Element;
    firstRadioLabel?: string;
    secondRadioLabel?: string;
    fieldName: keyof FieldType<T>;
    value: boolean;
    onChange: (fieldName: any, value: string) => void;
    error?: string;
    disabled?: boolean;
    smallLabel?: string;
}

export function CustomYesNoRadio<T>(props: IProps<T>) {
    const { label, firstRadioLabel, secondRadioLabel, smallLabel, value, onChange, fieldName, error, disabled, ...rest } = props;
    const isMobile: boolean = useMediaQuery("screen and (max-width: 767px)") ? true : false;
    return (
        <FormControl component="fieldset">
            {isMobile ? (
                <FormLabel component="legend" style={smallLabel != "" ? { marginBottom: "3px", fontSize: "16px" } : { marginBottom: "3px", fontSize: "16px" }}>
                    {smallLabel ? label : ""}
                </FormLabel>
            ) : (
                <FormLabel component="legend" style={smallLabel != "" ? { marginBottom: "3px", fontSize: "12px" } : { marginBottom: "8px", fontSize: "12px" }}>
                    {smallLabel ? label : ""}
                </FormLabel>
            )}
            <FormLabel component="legend" style={isMobile ? { marginBottom: "12px", fontSize: "16px" } : { marginBottom: "8px", fontSize: "12px" }}>
                {smallLabel ? <span style={isMobile ? { fontSize: "14px", fontWeight: "normal" } : { fontSize: "10px", fontWeight: "normal" }}>{smallLabel}</span> : label}
            </FormLabel>
            <RadioGroup
                aria-label={"" + fieldName}
                name={"" + fieldName}
                value={value}
                row
                onChange={(e: any, val: string) => {
                    onChange(fieldName, val);
                }}
            >
                <FormControlLabel
                    control={<Radio checked={value} icon={<RadioSVG width={35} height={35} />} checkedIcon={<RadioCheckedSVG width={35} height={35} />} />}
                    checked={value}
                    label={<>{firstRadioLabel ? firstRadioLabel : "Yes"}</>}
                    value={"1"}
                    disabled={disabled}
                />
                <FormControlLabel
                    control={<Radio checked={!value} icon={<RadioSVG width={35} height={35} />} checkedIcon={<RadioCheckedSVG width={35} height={35} />} />}
                    checked={!value}
                    label={<>{secondRadioLabel ? secondRadioLabel : "No"}</>}
                    value={"0"}
                    disabled={disabled}
                />
            </RadioGroup>
            {error !== "" && <FormHelperText style={{ color: theme.palette.error.main }}>{error}</FormHelperText>}
        </FormControl>
    );
}
